import { NavLink, Routes, Route, Navigate, Link } from "react-router-dom";
import { BarChart3, Package, ShoppingCart, CalendarDays, Ticket, Newspaper, Users, Settings, ArrowLeft, Send, Globe, Link2, Star, ShieldCheck, Percent } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Header";
import NotificationBell from "@/components/NotificationBell";
import Overview from "@/pages/admin/Overview";
import Products from "@/pages/admin/Products";
import { Orders, Bookings } from "@/pages/admin/Orders";
import { UsersAdmin, SettingsAdmin } from "@/pages/admin/Misc";
import Coupons from "@/pages/admin/Promotions";
import Website from "@/pages/admin/Website";
import Domain from "@/pages/admin/Domain";
import Posts from "@/pages/admin/Posts";
import Broadcast from "@/pages/admin/Broadcast";
import Reviews from "@/pages/admin/Reviews";
import Warranty from "@/pages/admin/Warranty";
import Discounts from "@/pages/admin/Discounts";

const ALL = [
  ["overview", "Overview", BarChart3, ["superadmin"]],
  ["products", "Products & Inventory", Package, ["superadmin", "staff"]],
  ["orders", "Orders", ShoppingCart, ["superadmin", "staff"]],
  ["warranty", "Warranty", ShieldCheck, ["superadmin", "staff"]],
  ["bookings", "Workshop Bookings", CalendarDays, ["superadmin", "staff"]],
  ["discounts", "Discounts", Percent, ["superadmin"]],
  ["reviews", "Ratings", Star, ["superadmin", "staff"]],
  ["broadcast", "Broadcast", Send, ["superadmin"]],
  ["website", "Website", Globe, ["superadmin"]],
  ["domain", "Domain", Link2, ["superadmin"]],
  ["posts", "Blog & Vlog", Newspaper, ["superadmin"]],
  ["users", "Users & Roles", Users, ["superadmin"]],
  ["settings", "Settings", Settings, ["superadmin"]],
];
const PAGES = { overview: Overview, products: Products, orders: Orders, bookings: Bookings, coupons: Coupons, reviews: Reviews, warranty: Warranty, discounts: Discounts, posts: Posts, website: Website, domain: Domain, broadcast: Broadcast, users: UsersAdmin, settings: SettingsAdmin };

export default function Admin() {
  const { user } = useApp();
  const items = ALL.filter((x) => x[3].includes(user.role));
  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-[#FAFAFA]" data-testid="admin-layout">
      <aside data-print-hide className="md:w-64 bg-[#3B220C] text-white/80 md:min-h-screen md:sticky md:top-0 md:h-screen flex md:flex-col">
        <div className="p-6 hidden md:block"><Logo light small /><div className="flex items-center justify-between mt-2"><p className="text-[10px] font-mono tracking-[0.2em] text-[#C47A37]">{user.role.toUpperCase()}</p><NotificationBell light /></div></div>
        <div className="md:hidden flex items-center px-4"><NotificationBell light /></div>
        <nav className="flex md:flex-col overflow-x-auto md:overflow-x-visible md:overflow-y-auto flex-1 min-h-0">
          {items.map(([k, label, Icon]) => (
            <NavLink key={k} to={`/admin/${k}`} data-testid={`admin-nav-${k}`}
              className={({ isActive }) => `flex items-center gap-3 px-6 py-3 text-sm whitespace-nowrap transition-colors ${isActive ? "bg-white/10 text-white" : "hover:text-white"}`}>
              <Icon size={16} />{label}
            </NavLink>
          ))}
        </nav>
        <Link to="/" className="flex items-center gap-2 px-4 md:px-6 py-3 md:py-5 text-xs text-white/50 hover:text-white whitespace-nowrap" data-testid="admin-back-to-store"><ArrowLeft size={14} /><span className="hidden md:inline">Back to store</span></Link>
      </aside>
      <main className="flex-1 p-5 sm:p-10 min-w-0">
        <Routes>
          <Route index element={<Navigate to={items[0][0]} replace />} />
          {items.map(([k]) => { const C = PAGES[k]; return <Route key={k} path={k} element={<C />} />; })}
          <Route path="*" element={<Navigate to={`/admin/${items[0][0]}`} replace />} />
        </Routes>
      </main>
    </div>
  );
}

export const AdminTitle = ({ children, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8"><h1 className="font-serif text-4xl">{children}</h1>{action}</div>
);
export const Btn = ({ className = "", ...p }) => <button {...p} className={`bg-[#3B220C] text-white px-5 py-2.5 text-sm hover:bg-[#4A2C11] transition-colors disabled:opacity-40 ${className}`} />;
export const Field = ({ label, children, className = "" }) => (<label className={`block space-y-1.5 ${className}`}><span className="text-xs text-[#6E6259]">{label}</span>{children}</label>);
export const inputCls = "w-full border border-[#E6DFD5] bg-white px-3 py-2 text-sm outline-none focus:border-[#8C4F27]";
